/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantProperty
 */
export interface TenantProperty {
    /**
     * 
     * @type {string}
     * @memberof TenantProperty
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TenantProperty
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TenantProperty
     */
    propertyId: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof TenantProperty
     */
    lettingId: Array<any>;
}

export function TenantPropertyFromJSON(json: any): TenantProperty {
    return TenantPropertyFromJSONTyped(json, false);
}

export function TenantPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'propertyId': json['propertyId'],
        'lettingId': json['lettingId'],
    };
}

export function TenantPropertyToJSON(value?: TenantProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'propertyId': value.propertyId,
        'lettingId': value.lettingId,
    };
}


